export const selectUserState = (state) => state.user;
export const selectUser = (state) => state.user.user;
export const selectGetMeLoading = (state) => state.user.loading;

export const selectSelectedTenant = (state) =>
  state.user.tenants[state.user.selectedTenantId];

export const selectSelectedTenantId = (state) => state.user.selectedTenantId;
export const selectSelectedTenants = (state) =>
  Object.values(state.user.tenants);

export const selectCurrentPlan = (state) => state.user.currentPlan;
export const selectPlanNote = (state) => state.user.planNote;
